import CollectionDetailPage from '../CollectionDetailPage';
export default function LivingRoomPage() { return <CollectionDetailPage collectionId="living-room" />; }
